import { RoleV1 } from "../types.generated";
import { roleNameV1 } from "./parse";
import {
  isActiveMobileRoleV1,
  isActiveRoleV1,
  isArcgisAdminRoleV1,
  isMapDownloaderRoleV1,
  isMapViewerRoleV1,
  isSuperuserRoleV1,
  isSurveyAdminRoleV1,
  isSurveyDownloaderRoleV1,
  isSurveyorRoleV1,
  isSurveyViewerRoleV1,
  isUserAdminRoleV1,
} from "./guard";

export function roleLabelV1(role: RoleV1): string {
  return isSuperuserRoleV1(role)
    ? "Superuser"
    : isActiveRoleV1(role)
    ? "Active"
    : isActiveMobileRoleV1(role)
    ? "Mobile Access"
    : isUserAdminRoleV1(role)
    ? "User Admin"
    : isArcgisAdminRoleV1(role)
    ? "ArcGIS Admin"
    : isSurveyViewerRoleV1(role)
    ? "View"
    : isSurveyorRoleV1(role)
    ? "Surveyor"
    : isSurveyDownloaderRoleV1(role)
    ? "Download"
    : isSurveyAdminRoleV1(role)
    ? "Survey Admin"
    : isMapViewerRoleV1(role)
    ? "View"
    : isMapDownloaderRoleV1(role)
    ? "Download"
    : roleNameV1(role);
}
